import React, { useState } from 'react';
import { useErrorToast, useDismissError } from './ErrorToastContext';

// Click-to-rename filename — a local draft, only sent to the server on
// Save; Cancel discards it with nothing written. Mirrors the Media
// Library's own row-level rename (MediaLibraryPage.js's MediaRow) so
// renaming reads the same everywhere it's offered — this is the same
// media_images.original_filename column either way, just editable from
// wherever an image happens to be showing (e.g. straight off the Product
// Media page, without a trip to the Library, for bulk product setup).
function EditableFilename({ filename, onSave, style }) {
  const showError = useErrorToast();
  const dismissError = useDismissError();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(filename);
  const [saving, setSaving] = useState(false);

  const startEdit = () => {
    setDraft(filename);
    setEditing(true);
  };

  const save = async () => {
    const trimmed = draft.trim();
    if (!trimmed) return showError(null, 'Filename cannot be empty.');
    if (trimmed === filename) return setEditing(false);
    setSaving(true);
    try {
      await onSave(trimmed);
      setEditing(false);
      dismissError();
    } catch (err) {
      showError(err, 'Could not rename image');
    }
    setSaving(false);
  };

  if (editing) {
    return (
      <div style={{ display: 'flex', gap: 4, alignItems: 'center', ...style }}>
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); save(); }
            if (e.key === 'Escape') setEditing(false);
          }}
          autoFocus
          disabled={saving}
          style={{ flex: 1, minWidth: 0, padding: '3px 6px', borderRadius: 4, border: '1px solid #bfc8d6', fontSize: 12 }}
        />
        <button type="button" className="link-button" onClick={save} disabled={saving} style={{ fontSize: 11 }}>
          {saving ? 'Saving...' : 'Save'}
        </button>
        <button type="button" className="link-button" onClick={() => setEditing(false)} disabled={saving} style={{ fontSize: 11 }}>
          Cancel
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={startEdit}
      title={`${filename} — click to rename`}
      style={{ background: 'none', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer', textAlign: 'left', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', ...style }}
    >
      {filename}
    </button>
  );
}

export default EditableFilename;
